function Uploads() {
  return <div>Welcome to the uploads page</div>;
}

export default Uploads;
